import React, {FC} from 'react';

import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {DropdownItemNestedIcon} from '../dropdownItemNestedIcon';

interface AnswerFolderDropdownItemFolderIconProps {
  nestingLevel: number;
}

export const AnswerFolderDropdownItemFolderIcon: FC<AnswerFolderDropdownItemFolderIconProps> = (props) => {
  const theme = useUserTheme();

  return (
    <DropdownItemNestedIcon nestingLevel={props.nestingLevel}>
      <Icon name="folder" color={theme.greys.shade70} />
    </DropdownItemNestedIcon>
  );
};
